import { render, staticRenderFns } from "./ObrasCadastroDialog.vue?vue&type=template&id=7d478308&scoped=true&"
import script from "./ObrasCadastroDialog.vue?vue&type=script&lang=js&"
export * from "./ObrasCadastroDialog.vue?vue&type=script&lang=js&"
import style0 from "./ObrasCadastroDialog.vue?vue&type=style&index=0&id=7d478308&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d478308",
  null
  
)

export default component.exports